import {
  organizationIdSelector,
  organizationSelector,
  patientIdSelector,
  patientSerSelector
} from '../redux/app/selectors.ts';

export function getDefaultParam(paramName: string) {
  switch (paramName) {
    case 'organization':
      return organizationSelector();
    case 'patientId':
      return patientIdSelector();
    case 'patientSer':
      return patientSerSelector();
    case 'organizationId':
      return organizationIdSelector();
  }
}